import classnames from 'classnames/bind'
import React, { useState } from 'react'

import Cta, { CtaProps } from '~/components/Cta'
import Image, { ImageProps } from '~/components/Image'
import ImageWithPlaceHolder from '~/components/ImageWithPlaceholder'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface UnSupportedProps {
  className?: string
  logo?: ImageProps
  image?: ImageProps
  title?: RichTextBlock[]
  text?: RichTextBlock[]
  browserCta?: CtaProps
  tryAnywayCta?: CtaProps
  loginCta?: CtaProps
}

/**
 * UnSupported component
 * @param props
 * @returns UnSupported component
 */
function UnSupported({
  className,
  title,
  text,
  browserCta,
  tryAnywayCta,
  loginCta,
  logo,
  image,
}: UnSupportedProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const titleStyle = useStyle({ textPreset: 'title-section-page' })
  const textStyle = useStyle({ textPreset: 'text-paragraph' })

  const [show, setShow] = useState(true)

  return (
    <div className={cx(css.UnSupported, className, { show })}>
      <div className={cx(css.grid, gridStyle)}>
        <div className={css.content}>
          {logo && (
            <ImageWithPlaceHolder
              className={css.logo}
              layout="responsive"
              {...logo}
            />
          )}
          {image && (
            <ImageWithPlaceHolder
              className={css.image}
              layout="responsive"
              {...image}
            />
          )}
          {title && (
            <RichText className={cx(css.title, titleStyle)} render={title} />
          )}
          {text && (
            <RichText className={cx(css.text, textStyle)} render={text} />
          )}
          <div className={css.ctas}>
            <div className={css.primaryCta}>
              {browserCta && <Cta {...browserCta} />}
            </div>
            <div className={css.secondaryCtas}>
              {tryAnywayCta && (
                <Cta
                  className={css.cta}
                  onClick={() => setShow(false)}
                  {...tryAnywayCta}
                />
              )}
              {loginCta && <Cta className={css.cta} {...loginCta} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

UnSupported.defaultProps = {}

export default UnSupported
